import { EntityModel } from '@/interfaces'
import {
  ALL_TEXT_WITH_IMAGE_BLOCKS_QUERY,
  CREATE_TEXT_WITH_IMAGE_BLOCK_MUTATION,
  DELETE_TEXT_WITH_IMAGE_BLOCK_MUTATION,
  FORCE_DELETE_TEXT_WITH_IMAGE_BLOCK_MUTATION,
  SINGLE_TEXT_WITH_IMAGE_BLOCK_QUERY,
  UPDATE_TEXT_WITH_IMAGE_BLOCK_MUTATION,
} from './graphql'
import mediaFileEntity from '@/entities/mediaFile/entity'
import imageGalleryEntity from '@/entities/imageGallery/entity'
import linkEntity from '@/entities/link/entity'

const cmsTextWithImageBlockModel: EntityModel = {
  name: 'textWithImageBlock',
  namePlural: 'textWithImageBlocks',
  uniqueName: 'cmsTextWithImageBlock',
  uniqueNamePlural: 'cmsTextWithImageBlocks',
  path: 'cms/blocks/text_with_image_block',
  baseUrl: '/cms/blocks/text_with_image_blocks',
  translationPrefix: 'entities:cmsTextWithImageBlock.',
  getDisplayName: (values: any) => {
    return 'Text with image block'
  },
  gql: {
    getAll: ALL_TEXT_WITH_IMAGE_BLOCKS_QUERY,
    getSingle: SINGLE_TEXT_WITH_IMAGE_BLOCK_QUERY,
    create: CREATE_TEXT_WITH_IMAGE_BLOCK_MUTATION,
    update: UPDATE_TEXT_WITH_IMAGE_BLOCK_MUTATION,
    delete: DELETE_TEXT_WITH_IMAGE_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_TEXT_WITH_IMAGE_BLOCK_MUTATION,
  },
  attributes: {
    title: {
      name: 'title',
      label: 'entities:cmsTextWithImageBlock.attributes.title.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    subtitle: {
      name: 'subtitle',
      label: 'entities:cmsTextWithImageBlock.attributes.subtitle.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    text: {
      name: 'text',
      label: 'entities:cmsTextWithImageBlock.attributes.text.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'wysiwyg',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    imagePosition: {
      name: 'imagePosition',
      label: 'entities:cmsTextWithImageBlock.attributes.imagePosition.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'right',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:cmsTextWithImageBlock.attributes.imagePosition.selectOptions.left.label',
          value: 'left',
        },
        {
          label: 'entities:cmsTextWithImageBlock.attributes.imagePosition.selectOptions.right.label',
          value: 'right',
        },
      ],
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    image: {
      name: 'image',
      label: 'entities:cmsTextWithImageBlock.attributes.image.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    imageFixedAspectRatio: {
      name: 'imageFixedAspectRatio',
      label: 'entities:cmsTextWithImageBlock.attributes.imageFixedAspectRatio.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    gallery: {
      name: 'gallery',
      label: 'entities:cmsTextWithImageBlock.attributes.gallery.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return imageGalleryEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    link: {
      name: 'link',
      label: 'entities:cmsTextWithImageBlock.attributes.link.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return linkEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsTextWithImageBlockModel
